import React, {useEffect} from 'react';
import './Landing.css';
import Banner from "./Banner";
import Products from "./Products";
import Producer from "./Producer";

const Landing = () => {
    useEffect(() => {
        window.scrollTo({top: 0, behavior: "smooth"});
    }, [])

    return (
        <div className='Landing__container'>
            <Banner/>
            <Products/>
            <Producer/>
        </div>
    )
}

export default Landing;
